import {
  Component,
  Injector,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DirectReportsLookupComponent } from '@app/components/direct-reports-lookup/direct-reports-lookup.component';
import { DirectReportsFacade } from '@app/components/direct-reports/direct-reports.facade';

@Component({
  selector: 'app-direct-reports',
  templateUrl: './direct-reports.component.html',
  styleUrls: ['./direct-reports.component.css'],
  providers: [DirectReportsFacade],
})
export class DirectReportsComponent
  extends AppComponentBase
  implements OnInit, OnChanges {
  @ViewChild('directReportsLookup', { static: true })
  directReportsLookup: DirectReportsLookupComponent;

  @Input() staff;
  @Input() ownDetailsEdit: Boolean;

  user;
  saving = false;
  doNotHaveSubordinates: boolean;

  constructor(injector: Injector, private facade: DirectReportsFacade) {
    super(injector);
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.staff) {
      this.user = changes.staff.currentValue;
      if (this.user.subordinates) {
        this.doNotHaveSubordinates = this.user.subordinates.staffSubordinatesHierarchyHierarchy.doNotHaveSubordinates;
        this.directReportsLookup.selectedSubordinaries = [
          ...this.user.subordinates.subordinatedStaffDetails,
        ];
      }
    }
  }

  openSelectUserModal() {
    this.directReportsLookup.superiorStaffId = this.user.staffId;
    this.directReportsLookup.show();
  }

  getNewUserId(): void {
    return;
  }

  saveData() {
    this.saving = true;

    if (this.ownDetailsEdit) {
      return this.facade.EditMyOwnSubordinatesHierarchyInput(
        this.doNotHaveSubordinates,
        !this.doNotHaveSubordinates
          ? this.directReportsLookup.selectedSubordinaries.map(
              (item) => item.staffId
            )
          : []
      );
    } else {
      return this.facade.EditStaffSubordinatesHierarchyInput(
        this.doNotHaveSubordinates,
        !this.doNotHaveSubordinates
          ? this.directReportsLookup.selectedSubordinaries.map(
              (item) => item.staffId
            )
          : [],
        this.user.staffId
      );
    }
  }

  save() {
    this.saveData().subscribe(
      (x) => {
        this.saving = false;
        abp.event.trigger('app.show.mySettingsManualModalClose');
        this.notify.success(this.l('SavedSuccessfully'));
      },
      (err) => {
        this.saving = false;
      }
    );
  }
}
